import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import Api from "../Api/Api.json";

const fetchData = async (id) => {
    const headers = { headers: { "Content-Type": "application/json" } };
    const url = Api.FITNESS_API;
    const requestData = {
        task: "getVitals",
        patient_id: id,
    };
    const response = await axios.post(url, requestData, headers);
    if (!response.data) {
        throw new Error("Network response was not ok");
    }
    return response.data;
};

export const useVitalsData = (id) => {
    // Use React Query to fetch and cache data
    return useQuery({
        queryKey: ["vitalsData", id], // Unique key for this query
        queryFn: () => fetchData(id), // Function to fetch data
        staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
        cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
    });
}
